function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["node"];
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2017, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import msgs from '../../nls/setup/deploy/deploy.properties';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from '@carbon/react';
import '../../scss/common/_markdown.scss';

// custom renderers for markdown components, e.g. links
var COMPONENTS = {
  a: function a(_ref) {
    var node = _ref.node,
      props = _objectWithoutProperties(_ref, _excluded);
    if (props && props.children && props.children.length) {
      if (props.children[0] === 'tutorial') {
        props['data-analytics-track'] = 'tutorial';
      } else if (props.children[0] === 'Lite') {
        props['data-analytics-track'] = 'cd-lite-plan';
      }
    }
    // target='_blank' implies rel='noopener', rel='ignore' is to work around a limitation of InlineNotification
    // where it does not allow links or interactable content
    return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
      target: "_blank",
      referrerPolicy: "no-referrer",
      rel: "ignore"
    }));
  }
};
var Markdown = /*#__PURE__*/function (_React$Component) {
  function Markdown(props) {
    var _this;
    _classCallCheck(this, Markdown);
    _this = _callSuper(this, Markdown, [props]);
    _this.gitUrl = /*#__PURE__*/React.createRef();
    _this.gitBranch = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Markdown, _React$Component);
  return _createClass(Markdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.gitUrl.current) {
        var templateGitRepoDiv = this.gitUrl.current;
        if (templateGitRepoDiv.getElementsByTagName("a")[0]) {
          templateGitRepoDiv.getElementsByTagName("a")[0].setAttribute("data-analytics-track", "template-repo-link");
        }
      } else if (this.gitBranch.current) {
        var templateGitBranchDiv = this.gitBranch.current;
        if (templateGitBranchDiv.getElementsByTagName("a")[0]) {
          templateGitBranchDiv.getElementsByTagName("a")[0].setAttribute("data-analytics-track", "template-repo-branch");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$content, _this$props$content2;
      if (!this.props.content) return null;
      var locale = (_this$props$content = this.props.content) === null || _this$props$content === void 0 ? void 0 : _this$props$content.locale;
      var data = (_this$props$content2 = this.props.content) === null || _this$props$content2 === void 0 ? void 0 : _this$props$content2.markdown;
      var isImage = typeof data === "string" && data.startsWith("![](data:image/svg+xml;base64") ? true : false;
      var markdown = isImage ?
      /*#__PURE__*/
      //case for payload with image data and locale
      React.createElement(ReactMarkdown, {
        components: {
          img: function img(image_data) {
            return /*#__PURE__*/React.createElement("img", {
              alt: msgs.get('template.image.description', locale),
              src: image_data.src
            });
          }
        }
      }, data) :
      /*#__PURE__*/
      //fallback to orignal behaviour
      React.createElement(ReactMarkdown, {
        components: COMPONENTS
      }, this.props.content);
      if (this.props.id === "gitUrl" || this.props.id === "gitBranch") {
        return /*#__PURE__*/React.createElement("div", {
          ref: this[this.props.id],
          className: 'markdown ' + (this.props.className || ''),
          "aria-label": this.props.ariaLabel,
          id: this.props.id
        }, markdown);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: 'markdown ' + (this.props.className || ''),
        "aria-label": this.props.ariaLabel,
        id: this.props.id
      }, markdown);
    }
  }]);
}(React.Component);
export { Markdown as default };